import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cyclops-testimonial',
  templateUrl: './cyclops-testimonial.component.html',
  styleUrls: ['./cyclops-testimonial.component.scss']
})
export class cyclopsTestimonialComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  
  users = [
    { 
      img:"assets/images/cyclops/testimonial/quote.png",
      testimonial:"Cyclops works with military forces, homeland security agencies, defense contractors, and allied governments seeking tailored operational support and next-generation mission solutions."
    },
    {
    img: "assets/images/cyclops/testimonial/quote.png",
    testimonial: `Cyclops works with:<br>
    • Defense Ministries and Armed Forces<br>
    • Homeland Security and Intelligence Agencies<br>
    • Government Contractors and Integrators<br>
    • Allied Governments and Security Institutions<br><br>
    We support clients across the MENA region and beyond — providing scalable, ITAR-compliant solutions in UAVs, surveillance, communications, and field services.`
  }

  ]
  
  testimonialCarouselOptions= {
    items: 1,
    margin: 0,
    dots: true,
    nav: false,
    autoplay: false,
    slideSpeed: 300,
    paginationSpeed: 400,
    loop: true
  }



}
